/* unplugin-vue-components disabled */import { render } from "./reply.vue?vue&type=template&id=b6a968a8&scoped=true&ts=true"
import script from "./reply.vue?vue&type=script&lang=ts"
export * from "./reply.vue?vue&type=script&lang=ts"

import "./reply.vue?vue&type=style&index=0&id=b6a968a8&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a968a8"]])

export default __exports__